import React from "react";
import { useObjectStore } from "../storez/ObjectStore";

export default class ObjectPrinter extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      availableObjects: useObjectStore.getState().getObjects(),
    };
  }

  componentDidMount() {
    this.unsubscribe = useObjectStore.subscribe(this.onChange);

    setTimeout(() => {
      void useObjectStore.getState().fetch();
    }, 0);
  }

  componentWillUnmount() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = undefined;
    }
  }

  onChange = () => {
    this.setState({
      availableObjects: useObjectStore.getState().getObjects(),
    });
  };

  static getObjectsText(values) {
    let ret = [];
    for (let val of values) {
      const resolved_object = useObjectStore.getState().getObject(val);
      if (resolved_object) {
        ret.push(`${resolved_object["name"]}, `);
      } else {
        ret.push(val);
      }
    }
    return ret;
  }

  render_Objects = () => {
    if (this.props.values.length === 0) {
      return <span></span>;
    }

    const objectsText = ObjectPrinter.getObjectsText(this.props.values);

    let ret = [];
    for (let val of objectsText) {
      ret.push(<span key={"object" + ret.length}>{val}</span>);
    }
    return ret;
  };

  render() {
    return <span>{this.render_Objects()}</span>;
  }
}
